import animatedLogo from '../../assets/logo/bloomays_animated_logo.svg';

const LoadingLogo = (): React.ReactElement => {
  const logoStyles: React.CSSProperties = {
    height: '6vmin',
    pointerEvents: 'none' as const,
    margin: '20px',
  };

  return (<img src={animatedLogo} style={logoStyles} alt="logo" />) as React.ReactElement;
};

export default LoadingLogo;
export { LoadingLogo };
